<template>
  <section class="section" id="services">
    <div class="wrap">
      <div class="sec-head reveal" v-reveal>
        <p class="sec-eyebrow">01 / SERVICES / 服务</p>
        <h2>我们的服务</h2>
        <p>所有项目均为定制交付, 基于你的业务场景设计, 不套模板。</p>
      </div>
      <div class="cards">
        <div class="card reveal" v-reveal>
          <p class="card-idx">ai-app</p>
          <h3>AI 应用定制</h3>
          <p>招生咨询、学员答疑、评论私信里的重复判断交给模型, 人只做审阅和例外处理。适用于线索分发、内容合规检查、资料与数据整理等场景。</p>
          <div class="tags">
            <span class="tag">招生咨询</span>
            <span class="tag">学员答疑</span>
            <span class="tag">评论私信</span>
          </div>
        </div>
        <div class="card reveal" v-reveal>
          <p class="card-idx">agent</p>
          <h3>智能体搭建</h3>
          <p>以你的课程、讲义和内容库做知识底座, 搭出能答学员问题、帮团队出选题的 AI 助手, 可接入公众号、小程序、社群与网页。</p>
          <div class="tags">
            <span class="tag">课程答疑</span>
            <span class="tag">内容选题</span>
            <span class="tag">私域陪跑</span>
          </div>
        </div>
        <div class="card reveal" v-reveal>
          <p class="card-idx">wechat</p>
          <h3>微信生态定制</h3>
          <p>公众号、小程序与企业微信的定制开发, 从需求梳理、设计到上线运维, 全流程交付。这是我们的老本行, 干了十年。</p>
          <div class="tags">
            <span class="tag">小程序</span>
            <span class="tag">公众号</span>
            <span class="tag">企业微信</span>
          </div>
        </div>
        <div class="card reveal" v-reveal>
          <p class="card-idx">web-app</p>
          <h3>网站与 APP 开发</h3>
          <p>企业官网、业务工具与内部系统的设计、开发与部署, 性能与体验并重, 交付后含文档与培训。</p>
          <div class="tags">
            <span class="tag">官网</span>
            <span class="tag">工具</span>
            <span class="tag">内部系统</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ServicesSection'
}
</script>
